document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('[data-ocean-header]');
  const toast=document.querySelector('[data-ocean-toast]');
  let toastTimer;
  const say=message=>{if(!toast)return;toast.textContent=message;toast.classList.add('visible');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('visible'),2600)};

  const updateScroll=()=>{
    header?.classList.toggle('scrolled',window.scrollY>30);
    document.querySelectorAll('[data-ocean-parallax]').forEach(el=>{const rect=el.parentElement.getBoundingClientRect();el.style.transform=`translateY(${(rect.top+rect.height/2)*.08}px) scale(1.04)`});
  };
  window.addEventListener('scroll',updateScroll,{passive:true});updateScroll();

  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target)}}),{threshold:.12});
  document.querySelectorAll('.ocean-reveal:not(.visible)').forEach(el=>observer.observe(el));

  const menuButton=document.querySelector('[data-ocean-menu-button]');
  const mobilePanel=document.querySelector('[data-ocean-mobile-panel]');
  const closeMenu=()=>{menuButton?.setAttribute('aria-expanded','false');mobilePanel?.setAttribute('aria-hidden','true');mobilePanel?.classList.remove('is-open');document.body.style.overflow=''};
  menuButton?.addEventListener('click',()=>{const open=menuButton.getAttribute('aria-expanded')==='true';menuButton.setAttribute('aria-expanded',String(!open));mobilePanel.setAttribute('aria-hidden',String(open));mobilePanel.classList.toggle('is-open',!open);document.body.style.overflow=open?'':'hidden'});
  mobilePanel?.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu()});

  document.querySelectorAll('.ocean-product-form').forEach(form=>{
    const variants=JSON.parse(form.querySelector('[data-ocean-variants]')?.textContent||'[]');
    const options=[...form.querySelectorAll('[data-ocean-option]')];
    const variantInput=form.querySelector('[data-ocean-variant-id]');
    const submit=form.querySelector('[data-ocean-product-submit]');
    const price=document.querySelector('[data-ocean-price]');
    const currency=document.documentElement.lang==='pt-BR'?'BRL':'BRL';
    const updateVariant=()=>{const selected=options.map(select=>select.value);const variant=variants.find(item=>item.options.every((value,index)=>value===selected[index]));if(!variant)return;variantInput.value=variant.id;submit.disabled=!variant.available;submit.querySelector('span').textContent=variant.available?'Adicionar à sacola':'Indisponível';if(price)price.textContent=new Intl.NumberFormat('pt-BR',{style:'currency',currency}).format(variant.price/100);history.replaceState({},'',`${location.pathname}?variant=${variant.id}`)};
    options.forEach(select=>select.addEventListener('change',updateVariant));
    const quantity=form.querySelector('[data-ocean-quantity]');
    form.querySelector('[data-ocean-quantity-minus]')?.addEventListener('click',()=>{quantity.value=Math.max(1,Number(quantity.value)-1)});
    form.querySelector('[data-ocean-quantity-plus]')?.addEventListener('click',()=>{quantity.value=Math.max(1,Number(quantity.value)+1)});
  });

  document.querySelectorAll('[data-ocean-add]').forEach(button=>button.addEventListener('click',async()=>{
    const variantId=Number(button.dataset.oceanAdd);
    const cartAddUrl=`${document.body.dataset.oceanCartAddUrl||'/cart/add'}.js`;
    const originalLabel=button.textContent;
    if(!variantId)return;
    button.disabled=true;
    button.textContent='Adicionando...';
    try{
      const response=await fetch(cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
      if(!response.ok)throw new Error('cart_add_failed');
      const count=document.querySelector('[data-cart-count]');
      if(count)count.textContent=String(Number(count.textContent||0)+1);
      say('Peça adicionada à sua sacola.');
      button.textContent='Adicionado ✓';
      window.setTimeout(()=>{button.textContent=originalLabel;button.disabled=false},1600);
    }catch(error){
      say('Não foi possível adicionar agora. Abrindo a peça...');
      window.setTimeout(()=>window.location.assign(button.dataset.oceanProductUrl),900);
    }
  }));
  document.querySelector('#oceanNewsletter')?.addEventListener('submit',()=>say('Enviando seu cadastro...'));
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)document.querySelectorAll('video[autoplay]').forEach(video=>video.pause());
});
